import type {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {CircularLoader} from '../circular-loader';
import {cn} from '../lib/cn';

type OverlayLoaderSize = 'sm' | 'md' | 'lg' | 'xl';

export interface OverlayLoaderProps {
  isLoading: boolean;
  children: ReactNode;
  label?: string;
  loaderSize?: OverlayLoaderSize;
  showText?: boolean;
  className?: string;
  overlayClassName?: string;
}

export function OverlayLoader({
  isLoading,
  children,
  label,
  loaderSize = 'md',
  showText = true,
  className = '',
  overlayClassName = '',
}: OverlayLoaderProps) {
  const {t} = useTranslation();
  const resolvedLabel = label || t('loading');

  return (
    <div className={cn('relative', className)}>
      {children}
      {isLoading && (
        <div
          className={cn(
            'absolute inset-0 flex items-center justify-center bg-[rgb(255_255_255_/_0.6)]',
            overlayClassName,
          )}
        >
          <CircularLoader
            size={loaderSize}
            label={showText ? resolvedLabel : undefined}
            className="[--circular-loader-color:#4f46e5]"
          />
        </div>
      )}
    </div>
  );
}
